<template>
  <div v-if="custDetail" class="col-md requestlistdetail__content">
    <div class="requestlistdetail__content--title mb-3">SHIPPING DETAILS ADDRESS</div>
    <div v-for="(item, i) in data" :key="i" :class="styletable.row" v-show="item.required">
      <div :class="styletable.col1">{{ item.label }}</div>
      <div :class="styletable.col2">:</div>
      <div v-if="!canEdit" :class="styletable.col3">
        <div v-if="item.label === 'Shipment Date'">{{item.value ? getDateDefauld(item.value) : '-'}}</div>
        <div v-else>{{ item.value }}</div>
      </div>

      <div :class="styletable.col3" 
        v-else-if="canEdit && (
        item.label === 'Origin Country' ||
        item.label === 'Origin City' ||
        item.label === 'Destination Country' ||
        item.label === 'Destination City' ||
        item.label === 'Shipment Service')"
      >
        <div class="options__multiselect">
          <multiselect
            v-model="item.fieldDropdown"
            :options="getOptions(item)"
            placeholder="Select"
            :name="item.label"
            @input="chooseDropdown(item)"
            v-validate="{required : item.required}"
            label="name" selectedLabel=""
            :select-label="''" :deselect-label="''"
            >
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
        </div>
        <p v-if="errors.has(item.label)" class="global__texterror text-left py-1">
          {{ errors.first(item.label) }}
        </p>
      </div>

      <!-- date form -->
      <div v-else-if="canEdit && item.label === 'Shipment Date'" class="col-md-5 pl-1">
        <input type="date" class="input_field" :name="item.label" v-model="item.value">
        <p v-if="errors.has(item.label)" class="global__texterror text-left py-1">
          {{ errors.first(item.label) }}
        </p>
      </div>

      <div :class="styletable.col3" v-else>
        <b-form-textarea
          rows="3"
          max-rows="5"
          :placeholder="`Input ${item.label}`"
          :name="item.label"
          v-model="item.value"
          v-validate="{required : item.required}"
        />
        <p v-if="errors.has(item.label)" class="global__texterror text-left py-1">
          {{ errors.first(item.label) }}
        </p>
      </div>
    </div>
    <button class="button__bluecorporite mt-3" v-if="isLoadingEditIq">
      <b-spinner small variant="secondary"></b-spinner>
    </button>
    <button class="button__bluecorporite mt-3"
    v-else-if="!canEdit && !isLoadingEditIq" @click="chooseEdit(true)">Edit</button>

    <div class="row m-0 mt-3" v-else-if="canEdit">
      <button class="button__redcorporite mr-3" @click="updateData">Save</button>
      <button class="button__whitesquere" @click="chooseEdit(false)">Cancel</button>
    </div>
 </div>
</template>
<script>
import { mapGetters } from 'vuex'
import mixinShipmentDetails from '@/mixin/getters/shipment-details'
import mixinDateTime from '@/mixin/getters/date-time'
import mixinGetStatus from '@/mixin/getters/status-bid'

export default {
  name: 'AddressDetails',
  mixins: [mixinGetStatus, mixinShipmentDetails, mixinDateTime],
  props: {
    custDetail: Object,
    canEdit: Boolean
  },
  data () {
    return {
      form: {},
      styletable: {
        row: 'row m-0 mb-1 requeslistdetails__content--info',
        col1: 'col-md-4 pl-0',
        col2: 'col-md-0',
        col3: 'col-md-5 pl-1 textcolor textbold'
      },
      data: [
        {
          label: 'Shipment Service',
          payloadVar: 'shipmentService',
          value: '',
          required: true,
          fieldDropdown: ''
        },
        {
          label: 'Origin Country',
          payloadVar: 'originCountryName',
          value: '',
          required: true,
          fieldDropdown: ''
        },
        {
          label: 'Origin City',
          payloadVar: 'originCityName',
          value: '',
          required: true,
          fieldDropdown: ''
        },
        {
          label: 'Pickup Address',
          payloadVar: 'originAddress',
          value: '',
          required: false
        },
        {
          label: 'Destination Country',
          payloadVar: 'destinationCountryName',
          value: '',
          required: true,
          fieldDropdown: ''
        },
        {
          label: 'Destination City',
          payloadVar: 'destinationCityName',
          value: '',
          required: true,
          fieldDropdown: ''
        },
        {
          label: 'Destination Address',
          payloadVar: 'destinationAddress',
          value: '',
          required: false
        },
        {
          label: 'Shipment Date',
          payloadVar: 'shipmentDate',
          value: '',
          required: true
        }
      ],
      optionShipmentService: [
        { name: 'Door to Door', value: 'dtd' },
        { name: 'Door to Port', value: 'dtp' },
        { name: 'Port to Port', value: 'ptp' },
        { name: 'Port to Door', value: 'ptd' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      countryList: 'settingCompany/countries',
      errorCountryList: 'settingCompany/countriesError',
      isLoadingCountryList: 'settingCompany/countriesIsLoading',

      originCity: 'city/city',
      errorOriginCity: 'city/error',
      isLoadingOriginCity: 'city/isLoading',

      destinationCity: 'city/destinationCities',
      errorDestinationCity: 'city/errorDestination',
      isLoadingDestinationCity: 'city/isLoadingDestination',

      editIq: 'instantQuote/editIq',
      errorEditIq: 'instantQuote/errorEditIq',
      isLoadingEditIq: 'instantQuote/isLoadingEditIq'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.form = Object.assign({}, this.custDetail.details.addressDetails)

      await this.fetchCountries()
      // Shipment Service
      const optionShipmentService = this.optionShipmentService.filter(item => item.value.includes(this.custDetail.bannerInfo.shipmentService))[0]
      this.data[0].value = optionShipmentService ? optionShipmentService.name : this.custDetail.details.addressDetails.shipmentService
      this.data[0].fieldDropdown = optionShipmentService || {}

      // Origin Country
      const optionOriginCountry = this.countryList.data.filter(item => item.name.includes(this.custDetail.details.addressDetails.originCountry))[0]
      this.data[1].value = optionOriginCountry ? optionOriginCountry.name : this.custDetail.details.addressDetails.originCountry
      this.data[1].fieldDropdown = optionOriginCountry || {}
      await this.fetchOriginCity(optionOriginCountry.code)

      // Origin City
      const optionOriginCity = this.originCity.filter(item => item.name.includes(this.custDetail.details.addressDetails.originCity))[0]
      this.data[2].value = optionOriginCity ? optionOriginCity.name : this.custDetail.details.addressDetails.originCity
      this.data[2].fieldDropdown = optionOriginCity || {}

      // Pickup Address
      this.data[3].required = this.custDetail.bannerInfo.shipmentService === 'dtp' || this.custDetail.bannerInfo.shipmentService === 'dtd'
      this.data[3].value = this.custDetail.details.addressDetails.originAddress

      // Destination Country
      const optionDestCountry = this.countryList.data.filter(item => item.name.includes(this.custDetail.details.addressDetails.destinationCountry))[0]
      this.data[4].value = optionDestCountry ? optionDestCountry.name : this.custDetail.details.addressDetails.destinationCountry
      this.data[4].fieldDropdown = optionDestCountry || {}
      await this.fetchDestinationCity(optionDestCountry.code)
      
      // Destination City
      const optionDestCity = this.destinationCity.filter(item => item.name.includes(this.custDetail.details.addressDetails.destinationCity))[0]
      this.data[5].value = optionDestCity ? optionDestCity.name : this.custDetail.details.addressDetails.destinationCity
      this.data[5].fieldDropdown = optionDestCity || {}

      // Destination Address
      this.data[6].required = this.custDetail.bannerInfo.shipmentService === 'ptd' || this.custDetail.bannerInfo.shipmentService === 'dtd'
      this.data[6].value = this.custDetail.details.addressDetails.destinationAddress

      // Shipment Date
      if (this.custDetail.details.addressDetails.shipmentDate !== '-') {
        this.data[7].value = this.custDetail.details.addressDetails.shipmentDate
      }
    },
    async fetchCountries () {
      await this.$store.dispatch('settingCompany/FETCH_COUNTRIES')
    },
    async fetchOriginCity (code) {
      await this.$store.dispatch('city/FETCH_CITIES', code)
    },
    async fetchDestinationCity (code) {
      await this.$store.dispatch('city/FETCH_CITIES_DESTINATION', code)
    },
    chooseEdit (data) {
      this.$emit('chooseEdit', data)
      this.init()
    },
    chooseDropdown (item) {
      if (item.label === 'Origin Country') {
        this.data[2].value = ''
        this.data[2].fieldDropdown = ''
        this.fetchOriginCity(this.data[1].fieldDropdown.code)
      }

      if (item.label === 'Destination Country') {
        this.data[5].value = ''
        this.data[5].fieldDropdown = ''
        this.fetchDestinationCity(this.data[4].fieldDropdown.code)
      }

      if (item.label === 'Shipment Service') {
        this.data[3].required = this.data[0].fieldDropdown.value === 'dtp' || this.data[0].fieldDropdown.value === 'dtd'
        this.data[6].required = this.data[0].fieldDropdown.value === 'ptd' || this.data[0].fieldDropdown.value === 'dtd'
      }
    },
    updateData () {
      // assigning the dropdown
      this.data.forEach((item) => {
        if (
          item.label === 'Origin Country' ||
          item.label === 'Destination Country' ||
          item.label === 'Origin City' ||
          item.label === 'Destination City' ||
          item.label === 'Shipment Service'
        ) {
          const value = item.fieldDropdown
          let itemName = ''
          let itemCode = ''
          if (item.label === 'Origin Country') {
            itemName = { originCountryName: value.name }
            itemCode = { originCountryCode: value.code }
          } else if (item.label === 'Destination Country') {
            itemName = { destinationCountryName: value.name }
            itemCode = { destinationCountryCode: value.code }
          } else if (item.label === 'Origin City') {
            itemName = { originCityName: value.name }
            itemCode = { originCityCode: value.code }
          } else if (item.label === 'Destination City') {
            itemName = { destinationCityName: value.name }
            itemCode = { destinationCityCode: value.code }
          } else if (item.label === 'Shipment Service') {
            itemName = { shipmentService: value.name }
            itemCode = { shipmentService: value.value }
          }
          this.form = Object.assign(this.form, itemName, itemCode)
        } else {
          // eslint-disable-next-line no-new-object
          const data = new Object()
          data[item.payloadVar] = item.value
          this.form = Object.assign(this.form, data)
        }
      })
      if (!this.form.shipmentDate || this.form.shipmentDate === '-') {
        this.form.shipmentDate = null
      }
      // Remove unnecessary attributes
      delete this.form.originCountry
      delete this.form.originCity
      delete this.form.destinationCountry
      delete this.form.destinationCity

      const payload = {
        editable: 'address',
        data: this.form
      }

      // Validate and send the payload
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('instantQuote/PUT_EDIT_IQ', {
            id: this.$route.params.id_iq,
            payload
          }).then(() => {
            if (!this.errorEditIq) {
              this.$store.dispatch('instantQuote/FETCH_IQ_BY_ID', this.$route.params.id_iq)
              this.$emit('chooseEdit', false)
            }
          })
        }
      })
    },
    getOptions (item) {
      let options = []
      if (item.label === 'Shipment Service') {
        options = this.optionShipmentService
      }
      if (item.label === 'Origin Country' || item.label === 'Destination Country') {
        options = this.countryList.data
      }
      if (item.label === 'Origin City') {
        options = this.originCity
      }
      if (item.label === 'Destination City') {
        options = this.destinationCity
      }
      return options
    },
    hideByShipmentService (service, type) {
      let status = true // ptp & dtd
      if (service === 'dtp') {
        switch (type) {
          case 'PICKUP': status = false
            break
        }
      } else if (service === 'ptd') {
        switch (type) {
          case 'DELIVERY': status = false
            break
        }
      } else if (service === 'dtd') {
        switch (type) {
          case 'PICKUP': status = false
            break
          case 'DELIVERY': status = false
            break
        }
      }
      return status
    },
    resetData () {
      this.init()
    }
  },
  created () {
    this.$eventHub.$on('reset-data', this.resetData)
  },
  beforeDestroy () {
    this.$eventHub.$off('reset-data')
  },
  watch: {
    custDetail (data) {
      if (data) {
        this.init()
      }
    }
  }
}
</script>
<style scoped>
.options__multiselect {
  .multiselect__placeholder {
    font-size: 14px;
  }
  .multiselect__tags {
    padding-top: 0;
    min-width: 70px;
  }
  .multiselect__single {
    font-size: 14px;
    color: #1D3354;
    padding-top: 3px;
  }
}

.input_field {
  width: 100%;
  font-size: 14px;
  color: #686868;
  padding: 3px 10px;
  height: 28px;
  border-radius: 2px;
  border: 1px solid #a9a9a9;
}

.form-control {
  font-size: 12px;
  font-weight: 400;
  color: #686868;
  overflow-y: auto !important;
  border: 1px solid #a9a9a9;
  border-radius: 0px;
  &:disabled {
    background-color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/requestList/detail-instant-quote/tabs-detail/AddressDetails.vue